<div class="intel-history">
    <div class="intel-history-header">
        <button type="button" class="intel-back-arrow" (click)="goBack()">
            <img src="assets/img/icons/intel-back-arrow.svg" width="12" height="18" alt="">
        </button>
        <div>
            <p class="intel-title">Historial operativo - {{data?.entity?.name}}</p>
            <p class="intel-subtitle">Detalle completo de los servicios realizados por {{groupBy === 'unit' ? 'la unidad' : (groupBy === 'driver' ? 'el operador' : 'el cliente')}} seleccionad{{groupBy === 'client' ? 'o' : 'a'}}</p>
        </div>
        <div class="intel-header-controls">
            <app-date-range-picker
                [from]="filterFrom" [to]="filterTo"
                (fromChange)="filterFrom = $event" (toChange)="filterTo = $event"
                (rangeApplied)="onFilterChanged()">
            </app-date-range-picker>
            <div class="intel-compare-pill">
                <span class="intel-compare-label">Comparar con:</span>
                <span class="intel-compare-value">Período anterior</span>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M6 9l6 6 6-6" stroke="#0a0a0a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
        </div>
    </div>

    <ng-container *ngIf="data">
        <div class="intel-kpi-grid">
            <app-kpi-card icon="assets/img/icons/intel-ranking-kpi-km.svg" iconBg="#dbeafe" label="Km recorrido total" [value]="formatKm(data.kpis.km_total.value)" [changePct]="data.kpis.km_total.change_pct" changeTone="good"></app-kpi-card>
            <app-kpi-card icon="assets/img/icons/intel-ranking-kpi-gasto.svg" iconBg="#dcfce7" label="Gasto operativo total" [value]="formatCurrency(data.kpis.gasto_total.value)" [changePct]="data.kpis.gasto_total.change_pct" changeTone="bad"></app-kpi-card>
            <app-kpi-card icon="assets/img/icons/intel-ranking-kpi-costo.svg" iconBg="#f3e8ff" label="Costo promedio por km" [value]="formatCurrency(data.kpis.cost_per_km.value)" [changePct]="data.kpis.cost_per_km.change_pct" changeTone="bad"></app-kpi-card>
            <app-kpi-card icon="assets/img/icons/intel-ranking-kpi-servicios.svg" iconBg="#ffedd4" label="Servicios realizados" [value]="data.kpis.services_count.value" [changePct]="data.kpis.services_count.change_pct" changeTone="good"></app-kpi-card>
        </div>

        <div class="intel-card">
            <p class="intel-card-title">Insights {{groupBy === 'unit' ? 'de la unidad' : (groupBy === 'driver' ? 'del operador' : 'del cliente')}}</p>
            <div class="intel-insights-grid">
                <div class="intel-insight" *ngIf="data.insights.most_frequent_route">
                    <div class="intel-insight-icon" style="background:#ffe2e2">
                        <img src="assets/img/icons/intel-insight-ruta-costosa.svg" width="20" height="20" alt="">
                    </div>
                    <div>
                        <p class="intel-insight-label">{{routeInsightLabel}}</p>
                        <p class="intel-insight-name">{{data.insights.most_frequent_route.route}}</p>
                        <p class="intel-insight-sub">{{data.insights.most_frequent_route.services_count}} servicios | {{formatKm(data.insights.most_frequent_route.km_total)}}</p>
                    </div>
                </div>
                <div class="intel-insight" *ngFor="let rel of data.insights.related" [ngSwitch]="rel?.type">
                    <ng-container *ngIf="rel">
                        <div class="intel-insight-icon" [ngSwitch]="rel.type" [style.background]="rel.type === 'unit' ? '#dcfce7' : '#dbeafe'">
                            <img *ngSwitchCase="'unit'" src="assets/img/icons/intel-insight-unidad-utilizada.svg" width="20" height="16" alt="">
                            <img *ngSwitchDefault src="assets/img/icons/intel-insight-operador-frecuentado.svg" width="20" height="20" alt="">
                        </div>
                        <div>
                            <p class="intel-insight-label">{{relatedLabel(rel.type)}}</p>
                            <p class="intel-insight-name">{{rel.name}}</p>
                            <p class="intel-insight-sub">{{rel.services_count}} servicios | {{formatKm(rel.km_total)}}</p>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="intel-card">
            <p class="intel-card-title">Línea de tiempo de servicios recientes</p>
            <div class="intel-timeline">
                <div class="intel-timeline-track"></div>
                <div class="intel-timeline-item" *ngFor="let ev of data.timeline" [ngClass]="statusClass(ev.status)">
                    <div class="intel-timeline-dot">
                        <img [src]="timelineIcon(ev.status)" width="16" height="16" alt="">
                    </div>
                    <p class="intel-timeline-date">{{formatDate(ev.date)}}</p>
                    <p class="intel-timeline-folio">Folio {{ev.folio}}</p>
                    <p class="intel-timeline-status">{{ev.status}}</p>
                </div>
            </div>
        </div>

        <div class="intel-card intel-table-card">
            <p class="intel-card-title intel-card-title--padded">Historial detallado de los servicios realizados por {{groupBy === 'unit' ? 'la unidad' : (groupBy === 'driver' ? 'el operador' : 'el cliente')}}</p>
            <div class="intel-table-scroll">
                <table class="intel-full-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Folio</th>
                            <th>Fecha</th>
                            <th>{{groupBy === 'client' ? 'Operador' : 'Cliente'}}</th>
                            <th>Km recorrido</th>
                            <th>Gasto total</th>
                            <th>Costo por km</th>
                            <th>Gasto principal</th>
                            <th>Estado operativo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let row of data.history.data; let i = index">
                            <tr class="intel-row-clickable" (click)="toggleRow(row)">
                                <td>{{(currentPage - 1) * perPage + i + 1}}</td>
                                <td>{{row.folio}}</td>
                                <td>{{formatDate(row.date)}}</td>
                                <td>{{groupBy === 'client' ? row.driver_name : row.client_name}}</td>
                                <td [class.cell-calculating]="row.status !== 'Finalizado'">{{row.status !== 'Finalizado' ? 'Calculando' : formatKm(row.km)}}</td>
                                <td [class.cell-calculating]="row.status !== 'Finalizado'">{{row.status !== 'Finalizado' ? 'Calculando' : formatCurrency(row.gasto_total)}}</td>
                                <td [ngClass]="row.status !== 'Finalizado' ? 'cell-calculating' : costPerKmClass(row.cost_per_km)">{{row.status !== 'Finalizado' ? 'Calculando' : (row.cost_per_km !== null ? formatCurrency(row.cost_per_km) : '—')}}</td>
                                <td>{{row.gasto_principal || '—'}}</td>
                                <td>
                                    <span class="intel-status-dot" [ngClass]="statusClass(row.status)">
                                        <span class="intel-status-dot-mark"></span>{{row.status}}
                                    </span>
                                </td>
                            </tr>
                            <tr class="intel-row-detail" *ngIf="expandedServiceId === row.service_id">
                                <td colspan="9">
                                    <div class="intel-detail-box" *ngIf="expandedDetail; else loadingDetail">
                                        <p class="intel-detail-title">Información detallada del servicio</p>
                                        <div class="intel-detail-grid">
                                            <div>
                                                <span class="intel-detail-label">Origen:</span>
                                                <span>{{expandedDetail.origin_address || '—'}}</span>
                                            </div>
                                            <div>
                                                <span class="intel-detail-label">Destino:</span>
                                                <span>{{expandedDetail.destination_address || '—'}}</span>
                                            </div>
                                            <div *ngIf="groupBy !== 'driver'">
                                                <span class="intel-detail-label">Operador:</span>
                                                <span>{{expandedDetail.driver_name || '—'}}</span>
                                            </div>
                                            <div>
                                                <span class="intel-detail-label">Auxiliar:</span>
                                                <span>{{expandedDetail.assistant_name || '—'}}</span>
                                            </div>
                                            <div *ngIf="groupBy !== 'unit'">
                                                <span class="intel-detail-label">Unidad:</span>
                                                <span>{{expandedDetail.unit_name || '—'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-template #loadingDetail>
                                        <p class="intel-detail-loading">Cargando detalle...</p>
                                    </ng-template>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="intel-pagination-bar" *ngIf="data.history.pagination.total > 0">
                <span>Mostrando {{(currentPage - 1) * perPage + 1}} a {{Math.min(currentPage * perPage, data.history.pagination.total)}} de {{data.history.pagination.total}} servicios</span>
                <div class="intel-pagination" *ngIf="data.history.pagination.last_page > 1">
                    <button type="button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">‹</button>
                    <button type="button" *ngFor="let p of pageNumbers" [class.active]="p === currentPage" (click)="goToPage(p)">{{p}}</button>
                    <button type="button" [disabled]="currentPage === data.history.pagination.last_page" (click)="goToPage(currentPage + 1)">›</button>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
